import {
  TAppElkAttendeeStatus,
  TAppElkInvitee,
  TAppElkInviteStatus,
  TAppElkProfile
} from 'TProtocol/prototypes/events/messages';

const Colors = [
  '#FFCB02', '#EF6623', '#ED1B2E', '#A3238E',
  '#7A469B', '#0359AA', '#02ABDD', '#4BB749'
];

export const calculateColor = (attendee?: TAppElkInvitee | TAppElkProfile) => {
  if (attendee === undefined) {
    return 'transparent';
  }

  const id = attendee.userId ?? attendee.name ?? ''

  let total = 0;
  for (let i = 0; i < id.length; i++) {
    total += id.charCodeAt(i);
  }

  return Colors[total % 8];
};

export const formatStatus = (invitee?: TAppElkInvitee) => {
  if (invitee === undefined) {
    return '';
  }

  if (invitee.rsvpStatus === TAppElkAttendeeStatus.INVITED) {
    switch (invitee.inviteStatus) {
      case undefined:
        return '';
      case TAppElkInviteStatus.PENDING:
        return 'Pending';
      case TAppElkInviteStatus.TRIGGERED:
        return 'Preparing to Send';
      case TAppElkInviteStatus.SUCCESS:
        return 'Sent Successfully';
      case TAppElkInviteStatus.FAILED:
        return 'Send Failure';
      default:
        const exhaustiveCheck: never = invitee.inviteStatus;
        throw new Error(`Unhandled invite status: ${exhaustiveCheck}`);
    }
  } else if (invitee.rsvpStatus === TAppElkAttendeeStatus.SEEN) {
    return 'Seen Event';
  } else if (invitee.rsvpStatus === TAppElkAttendeeStatus.YES) {
    return 'Attending';
  } else if (invitee.rsvpStatus === TAppElkAttendeeStatus.NO) {
    return 'Declined';
  } else if (invitee.rsvpStatus === TAppElkAttendeeStatus.HIDDEN) {
    return 'Hidden';
  } else {
    const exhaustiveCheck: never = invitee.rsvpStatus;
    throw new Error(`Unhandled invite status: ${exhaustiveCheck}`);
  }
}

const AttendeeStatusOrder: { [key in TAppElkAttendeeStatus]: number } = {
  [TAppElkAttendeeStatus.INVITED]: 1,
  [TAppElkAttendeeStatus.SEEN]: 2,
  [TAppElkAttendeeStatus.YES]: 3,
  [TAppElkAttendeeStatus.NO]: 4,
  [TAppElkAttendeeStatus.HIDDEN]: 5
};

const InviteStatusOrder: { [key in TAppElkInviteStatus]: number} = {
  [TAppElkInviteStatus.PENDING]: 1,
  [TAppElkInviteStatus.TRIGGERED]: 2,
  [TAppElkInviteStatus.FAILED]: 3,
  [TAppElkInviteStatus.SUCCESS]: 4
};

export const sortInvitees = (invitees: TAppElkInvitee[]): TAppElkInvitee[] => {
  const pending: TAppElkInvitee[] = [];
  const other: TAppElkInvitee[] = [];

  for (const invitee of invitees) {
    if (invitee.inviteStatus === TAppElkInviteStatus.PENDING) {
      pending.push(invitee);
    } else {
      other.push(invitee);
    }
  }

  return [...pending, ...other.sort(sortByName)];
};

export const sortByName = (a: TAppElkInvitee, b: TAppElkInvitee): number => {
   return (a?.name?.toLowerCase() ?? '') > (b?.name?.toLowerCase() ?? '') ? 1 : -1;
};

const NameRegex = /^([^ ]*) (.*)$/;

export const parseName = (name: string): [string, string] => {
  const match = name.match(NameRegex);
  return match ? [match[1], match[2]] : [name, ''];
}

